<button bitButton [bitMenuTriggerFor]="itemOptions" [buttonType]="buttonType" type="button">
  <i *ngIf="!hideIcon" class="bwi bwi-plus" aria-hidden="true"></i>
  {{ (hideIcon ? "createSend" : "new") | i18n }}
</button>
<bit-menu #itemOptions>
  <a bitMenuItem [routerLink]="buildRouterLink()" [queryParams]="buildQueryParams(sendType.Text)">
    <i class="bwi bwi-file-text" slot="start" aria-hidden="true"></i>
    {{ "sendTypeText" | i18n }}
  </a>
  <a bitMenuItem (click)="sendFileClick()">
    <div class="tw-flex tw-items-center tw-gap-2">
      <i class="bwi bwi-file" slot="start" aria-hidden="true"></i>
      {{ "sendTypeFile" | i18n }}
      <app-premium-badge></app-premium-badge>
    </div>
  </a>
</bit-menu>
